<template lang="pug">
.db-container
    v-card.database-card(light)
        v-card-title.brand.white--text.py-2 Database Users ({{ users.length }})
        v-card-text
            v-data-table(
                :headers="headers"
                :items="users"
                sort-by="group"
                class="database-table"
            )
                template(v-slot:top)
                    v-toolbar(flat)
                        v-spacer
                        v-dialog(
                            v-model='dialog'
                            max-width='900px'
                            light
                        )
                            template(v-slot:activator="{on, attrs}")
                                v-btn.brand.white--text(
                                    class="mb-2"
                                    v-bind="attrs"
                                    v-on="on"
                                ) New User
                            v-card
                                v-card-title.brand.white--text {{ formTitle }}
                                v-card-text
                                    v-container
                                        v-form( ref="form" v-model="valid" )
                                            v-row
                                                v-col(cols="12" sm="6" md="4")
                                                    v-text-field(
                                                        label="First Name"
                                                        v-model.trim="editedItem.nameFirst"
                                                        :rules="[rules.required]"
                                                        color="brand"
                                                    )
                                                v-col(cols="12" sm="6" md="4")
                                                    v-text-field(
                                                        label="Last Name"
                                                        v-model.trim="editedItem.nameLast"
                                                        :rules="[rules.required]"
                                                        color="brand"
                                                    )
                                                v-col(cols="12" sm="6" md="4" v-if="editedIndex === -1")
                                                    v-text-field(
                                                        label="Username"
                                                        v-model.trim="editedItem.username"
                                                        :rules="[rules.required, rules.minLength, rules.duplicate]"
                                                        color="brand"
                                                    )
                                                v-col(cols="12" sm="6" md="4")
                                                    v-text-field(
                                                        label="E-Mail"
                                                        v-model.trim="editedItem.email"
                                                        :rules="[rules.required, rules.email]"
                                                        color="brand"
                                                    )
                                                v-col(cols="12" sm="6" md="4")
                                                    v-select(
                                                        label="Group"
                                                        v-model.number="editedItem.groupId"
                                                        :items="groups"
                                                        item-text="name"
                                                        item-value="id"
                                                        :rules="[rules.required]"
                                                        color="brand"
                                                    )

                                v-card-actions
                                    v-spacer
                                    v-btn.actions.orange.white--text(
                                        text
                                        @click="close"
                                    ) Cancel
                                    v-btn.actions.brand.white--text(
                                        text
                                        :disabled="!valid"
                                        @click="save"
                                    ) Save
                        v-dialog(
                            v-model='dialogDelete'
                            max-width='500px'
                            light
                        )
                            v-card
                                v-card-title.brand.white--text Confirm Delete
                                v-card-text
                                    span.text-h6 Are you sure you want to delete this user?
                                v-card-actions
                                    v-spacer
                                    v-btn.orange.white--text(
                                        text
                                        @click="closeDelete"
                                    ) Cancel
                                    v-btn.brand.white--text(
                                        text
                                        @click="deleteItemConfirm"
                                    ) OK

                template(v-slot:item.actions="{ item }")
                    v-tooltip(bottom)
                        template(v-slot:activator="{ on, attrs }")
                            v-icon(
                                medium
                                color="blue"
                                @click="copyPwToClipboard(item)"
                                v-bind="attrs"
                                v-on="on"
                            ).pl-2  content_copy
                        span Copy Password
                    v-icon(
                        medium
                        color="warning"
                        @click="editItem(item)"
                    ).ml-3 edit
                    v-icon(
                        medium
                        color="red"
                        @click="deleteItem(item)"
                    ).ml-3 delete
                template(v-slot:no-data)
                    v-btn(
                        color="primary"
                        @click="initialize"
                    ) Reset

    v-snackbar(v-model='showAlert', dark, :timeout='3000') {{ message }}

</template>



<script lang="js">

export default {
    name: 'Database',
    data () {
        return {
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Last', value: 'nameLast', filterable: true},
                { text: 'First', value: 'nameFirst' },
                { text: 'Username', value: 'username' },
                { text: 'E-mail', value: 'email' },
                { text: 'Group', value: 'groupName' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                nameLast: '',
                nameFirst: '',
                username: '',
                email: '',
                groupName: '',
                groupId: 0,
            },
            defaultItem: {
                nameLast: '',
                nameFirst: '',
                username: '',
                email: '',
                groupName: '',
                groupId: 0,
            },
            users: [],
            dialogTitle: '',
            valid: false,
            rules: {
                required: value => !!value || 'Required.',
                email: value => /.+@.+\..+/.test(value) || 'E-mail must be valid',
                minLength: value => value && value.length >= 4 || 'Min 4 characters',
                duplicate: value => !this.checkUserExists(value) || 'Username already exists'
            },
            message: '',
        };
    },
    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'New User' : 'Edit User';
        },
        groups: {
            get () {
                const groups = [];
                const groupMap = new Map(this.users.map(({groupName, groupId}) => [groupName,groupId]));
                for(const [name,id] of groupMap) {
                    groups.push({name,id});
                }
                return groups;
            }
        },
        showAlert: {
            get () {
                return this.message !== '';
            },
            set (val) {
                if (val === false) {
                    this.message = '';
                }
            },
        },
    },
    watch: {
        dialog (val) {
            val || this.close();
        },
        dialogDelete (val) {
            val || this.closeDelete();
        },
    },
    created () {
        this.initialize();
    },
    methods: {
        initialize () {
            this.getUsers();
        },

        editItem (item) {
            this.editedIndex = this.users.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem (item) {
            this.editedIndex = this.users.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },

        deleteItemConfirm () {
            this.users.splice(this.editedIndex, 1);
            this.socketEmit('deleteDatabaseUser', this.editedItem, this.closeDelete);
        },

        close () {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.valid = false;
            });
        },

        closeDelete () {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save () {
            if (this.editedIndex > -1) {
                this.editedItem.groupName = this.groups.find(group => group.id === this.editedItem.groupId).name;
                Object.assign(this.users[this.editedIndex], this.editedItem);
            } else {
                this.users.push(this.editedItem);
            }
            this.socketEmit('saveDatabaseUser', this.editedItem, (result) => {
                if(this.editedIndex === -1) {
                    this.users[this.users.length - 1] = result;
                } else {
                    this.users[this.editedIndex] = result;
                }
                this.close();
                this.message = 'User saved successfully';
            });

        },

        /**
         * obtain the database user groups and users
         */
        getUsers () {
            this.socketEmit('getDatabaseUsers', null, (results) => {
                this.users = results || [];
            });
        },

        checkUserExists (username) {
            return this.users.some(u => u.username.toLowerCase() === username.toLowerCase());
        },

        copyPwToClipboard (item) {
            if(!item.encrypted_pw) {
                this.socketEmit('saveDatabaseUser', item, (result) => {
                    item = result; // update item with new encrypted_pw
                    if(result?.encrypted_pw) {
                        this.socketEmit('decryptPassword', {encryptedPassword: result.encrypted_pw}, (decryptedPw) => {
                            navigator.clipboard.writeText(decryptedPw).then(() => {
                                console.log('Password copied to clipboard');
                                this.message = 'Password copied to clipboard';
                            }).catch((e) => {
                                console.error('Failed to copy password', e);
                                this.message = 'Failed to copy password';
                            });
                        });
                    } else {
                        console.error('Failed to generate encrypted password for user', item);
                    }
                });
            }

            this.socketEmit('decryptPassword', {encryptedPassword: item.encrypted_pw}, (result) => {
                navigator.clipboard.writeText(result).then(() => {
                    console.log('Password copied to clipboard');
                    this.message = 'Password copied to clipboard';
                }).catch((e) => {
                    console.error('Failed to copy password', e);
                    this.message = 'Failed to copy password';
                });
            });
        }
    }
};

</script>

<style lang="css">

.database-card {
    width: 100%;
    margin-left: 32px;
    min-width: 900px;
}

.database-table {
    min-width: 900px;
}

.actions.v-btn--disabled.v-btn--text {
    background-color: #ddd !important;
}
.actions.v-btn--disabled > span {
    color: #777 !important;
    background-color: #ddd !important;
}

</style>
